import { CircleHelp } from "lucide-react"

import {
  Button,
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from "@f2e/ui/components/base"
import { TooltipContentPlus } from "@f2e/ui/components/base-plus"

export interface TipIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tip: string
  button?: React.ReactNode
  icon?: React.ReactNode
}

const TipIconButton = ({ tip, button, icon, ...props }: TipIconButtonProps) => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          {button ?? (
            <Button
              size="icon"
              variant="outline"
              className="border-0"
              style={{ backgroundColor: "transparent" }}
              {...props}
            >
              {icon ?? <CircleHelp className="h-4 w-4" />}
            </Button>
          )}
        </TooltipTrigger>
        <TooltipContentPlus>
          <p>{tip}</p>
        </TooltipContentPlus>
      </Tooltip>
    </TooltipProvider>
  )
}

export default TipIconButton
